import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { MatMenuItem } from '@angular/material/menu';
import { IfHasPrivilegesDirective } from '../../../modules/auth-utils/directives/if-has-privileges.directive';

@Component({
    selector: 'app-side-nav-menu-item',
    template: `
<ng-container *appIfHasPrivileges="requiredPrivileges">
  <a mat-menu-item [routerLink]="routerLink">
    <div class="flex flex-row">
      <div class="flex-1"><ng-content></ng-content></div>
      <div class="flex-1"></div>
      <!--
      <div class="flex-initial"><mat-icon>chevron_right</mat-icon></div>
      -->
    </div>
  </a>
  <mat-divider></mat-divider>
</ng-container>
`,
    styleUrls: ['./side-nav-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IfHasPrivilegesDirective, MatMenuItem, RouterLink, MatDivider]
})
export class SideNavMenuItemComponent {
  @Input()
  routerLink: any[] | string | null | undefined;
  @Input()
  requiredPrivileges: string[];
}
